import { Global } from "../../Global";

// Mock 配置数据
const mockConfigs = new Map<string, any>();

// 设置一些示例配置数据
mockConfigs.set("siteName", "BDD商城");
mockConfigs.set("version", "1.0.0");
mockConfigs.set("maxUploadSize", "10MB");
mockConfigs.set("supportedImageFormats", ["jpg", "png", "gif", "webp"]);
mockConfigs.set("defaultCurrency", "CNY");
mockConfigs.set("maintenanceMode", false);
mockConfigs.set("contactEmail", "support@bdd.com");
mockConfigs.set("contactPhone", "400-123-4567");
mockConfigs.set("businessHours", "09:00-18:00");
mockConfigs.set("timezone", "Asia/Shanghai");
mockConfigs.set('buyerHelpCenterH5Url', 'https://h5.superthem.com/webview/trading-rules'); 
mockConfigs.set('sellerRegisterH5Url', 'https://h5.superthem.com/webview/trading-rules'); 
mockConfigs.set(
  'sharePageDomain',
  JSON.stringify({
    buyerAppShareBaseLink: 'https://www.yuanling.com/buyer_app/',
    sellerAppShareBaseLink: 'https://www.yuanling.com/seller_app/',
    shareH5BaseLink: 'https://www.yuanling.com/',
  })
); 
mockConfigs.set('tradingRulesH5Url','https://h5.superthem.com/webview/trading-rules');
mockConfigs.set('userAgreementH5Url','https://h5.superthem.com/webview/about-us');
mockConfigs.set('privacyPolicyH5Url','https://h5.superthem.com/webview/privacy-policy');
mockConfigs.set('personalPrivacyH5Url','https://h5.superthem.com/webview/personal-information-protect');
mockConfigs.set('remoteThemProtocalUrl','https://h5.superthem.com/webview/trading-rules');
mockConfigs.set('enableFullAccess', 'false');
mockConfigs.set(
  'customer.service.config',
  JSON.stringify({
    buyer: {
      wechatNo: 'yuanling_cs',
      qrCodeUrl:
        'https://pub-img-wfile.yuanling.com/3/33/45/6/49/5eafce2266281a71a0f693d1483cf67851d1181f2de225f97a00a212.png',
    },
    seller: {
      wechatNo: 'superthem_business',
      qrCodeUrl:
        'https://pub-img-wfile.yuanling.com/3/33/45/6/49/5eafce2266281a71a0f693d1483cf67851d1181f2de225f97a00a212.png',
    },
  })
);

const buyerWebAdData = [
  { sellerId: "1", name: "张三", pictureUrl: "https://superthem.oss-cn-shanghai.aliyuncs.com/support/seller_ad/1.png", major: "Java工程师" },
  { sellerId: "2", name: "李四", pictureUrl: "https://superthem.oss-cn-shanghai.aliyuncs.com/support/seller_ad/2.png", major: "产品经理" },
  { sellerId: "3", name: "王五", pictureUrl: "https://superthem.oss-cn-shanghai.aliyuncs.com/support/seller_ad/3.png", major: "UI设计师" },
  { sellerId: "4", name: "赵六", pictureUrl: "https://superthem.oss-cn-shanghai.aliyuncs.com/support/seller_ad/4.png", major: "前端工程师" },
  { sellerId: "5", name: "孙七", pictureUrl: "https://superthem.oss-cn-shanghai.aliyuncs.com/support/seller_ad/5.png", major: "后端工程师" },
  { sellerId: "6", name: "周八", pictureUrl: "https://superthem.oss-cn-shanghai.aliyuncs.com/support/seller_ad/6.png", major: "测试工程师" },
];
mockConfigs.set("buyerWebAdData", JSON.stringify(buyerWebAdData));
mockConfigs.set(
  'appDownloadUrl',
  JSON.stringify({
    buyerAppQrCodeUrl:
      'https://yuanling-new.oss-cn-shanghai.aliyuncs.com/frontend-static/0a/0aab6a7e50d0dd83914800aa46ea610eb4f01afa85e23cc398dac643a5db423b.png?x-oss-process=style/original',
    sellerAppQrCodeUrl:
      'https://yuanling-new.oss-cn-shanghai.aliyuncs.com/frontend-static/0a/0aab6a7e50d0dd83914800aa46ea610eb4f01afa85e23cc398dac643a5db423b.png?x-oss-process=style/original',
    buyerAppUniversalLink: 'https://www.yuanling.com/buyer_app/',
    buyerAppAndroidLink: 'https://www.yuanling.com/buyer_app/',
    sellerAppUniversalLink: 'https://www.yuanling.com/seller_app/',
    sellerAppAndroidLink: 'https://www.yuanling.com/seller_app/',
  })
);

// 将 mock 数据添加到全局 mockData 中
Global.setMockData("getBasicConfigs", mockConfigs);
